<template>
  <div>
    <div class="" :class="btnPosition.btnHistoryClass || ''">
      <div
        :class="btnPosition.btnClass || ''"
        :style="btnPosition.btnStyle || ''"
        role="group"
      >
        <button class="btn btn-outline-primary next-btn" @click="previous">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          {{ $t("global.return") }}
        </button>
        <button class="btn btn-primary wizard-btn next-btn" @click="nextStep">
          {{ $t("global.save") }}
        </button>
      </div>
    </div>
    <div class="card inner-head card-small mb-4 mt-3">
      <!-- <div class="card-header inner-head border-bottom">
        <h6 class="inner-head__heading m-0">{{ $t('simple.absence.request.for') }} {{ user.lastName }} {{ user.firstName }}</h6>
      </div> -->
      <div class="card-body py-5">
        <div class="row">
          <div class="col-md-6 col-lg-6">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="step4-card">
                  <div class="d-flex">
                    <div class="svg-wrapper">
                      <svg
                        id="Composant_118_3"
                        data-name="Composant 118 – 3"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="44"
                        height="44"
                        viewBox="0 0 32.285 37.666"
                      >
                        <defs>
                          <clipPath id="clip-path">
                            <rect
                              id="Rectangle_30"
                              data-name="Rectangle 30"
                              width="3.587"
                              height="12.555"
                              fill="#303778"
                            />
                          </clipPath>
                          <clipPath id="clip-path-2">
                            <rect
                              id="Rectangle_29"
                              data-name="Rectangle 29"
                              width="731.797"
                              height="473.516"
                              fill="#303778"
                            />
                          </clipPath>
                          <clipPath id="clip-path-3">
                            <path
                              id="Tracé_56"
                              data-name="Tracé 56"
                              d="M1764.132,620.2h-8.545a3.587,3.587,0,0,1-3.587-3.587V604.055a3.587,3.587,0,0,1,3.587-3.587h8.545l20.153-8.968v37.666ZM1780.7,597.3l-15.719,6.751h-9.392v12.555h9.392l15.719,6.751Z"
                              transform="translate(-1752 -591.5)"
                              fill="#303778"
                            />
                          </clipPath>
                        </defs>
                        <g
                          id="Groupe_412"
                          data-name="Groupe 412"
                          transform="translate(3.587 12.555)"
                        >
                          <g
                            id="Groupe_55"
                            data-name="Groupe 55"
                            transform="translate(0 0)"
                            clip-path="url(#clip-path)"
                          >
                            <g
                              id="Groupe_54"
                              data-name="Groupe 54"
                              transform="translate(-396.39 -145.283)"
                            >
                              <g
                                id="Groupe_53"
                                data-name="Groupe 53"
                                transform="translate(0 0)"
                                clip-path="url(#clip-path-2)"
                              >
                                <rect
                                  id="Rectangle_28"
                                  data-name="Rectangle 28"
                                  width="12.555"
                                  height="21.523"
                                  transform="translate(391.906 140.799)"
                                  fill="#303778"
                                />
                              </g>
                            </g>
                          </g>
                        </g>
                        <g
                          id="Groupe_415"
                          data-name="Groupe 415"
                          clip-path="url(#clip-path-3)"
                        >
                          <g
                            id="Groupe_414"
                            data-name="Groupe 414"
                            transform="translate(-392.803 -132.728)"
                          >
                            <g
                              id="Groupe_413"
                              data-name="Groupe 413"
                              transform="translate(0 0)"
                              clip-path="url(#clip-path-2)"
                            >
                              <rect
                                id="Rectangle_144"
                                data-name="Rectangle 144"
                                width="41.253"
                                height="46.634"
                                transform="translate(388.319 128.244)"
                                fill="#303778"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div class="">
                      <p>{{ $t("days.off.request.urgent") }}</p>
                      <span>{{ $t("days.off.request.paid.leave") }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="step4-card">
                  <div class="d-flex">
                    <div class="svg-wrapper">
                      <svg
                        width="44px"
                        height="44px"
                        viewBox="0 0 44 44"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                        <title>Iconspace_Calendar</title>
                        <desc>Created with Sketch.</desc>
                        <g
                          id="Page-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            id="Antarmuka_One-Color-UI-element-1"
                            transform="translate(-338.000000, -242.000000)"
                          >
                            <g
                              id="Iconspace_Calendar"
                              transform="translate(336.000000, 240.000000)"
                            >
                              <polygon
                                id="Shape"
                                points="0 0 48 0 48 48 0 48"
                              />
                              <path
                                d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                id="Shape"
                                fill="#303778"
                                fill-rule="nonzero"
                              />
                              <polygon
                                id="Shape"
                                fill="#303778"
                                points="10 18 18 18 18 26 10 26"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div>
                      <p>{{ $t("days.off.request.type") }}</p>
                      <span>{{ formatDate(request.to) }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="step4-card">
                  <div class="d-flex">
                    <div class="svg-wrapper">
                      <svg
                        width="44px"
                        height="44px"
                        viewBox="0 0 44 44"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                        <title>Iconspace_Calendar</title>
                        <desc>Created with Sketch.</desc>
                        <g
                          id="Page-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            id="Antarmuka_One-Color-UI-element-1"
                            transform="translate(-338.000000, -242.000000)"
                          >
                            <g
                              id="Iconspace_Calendar"
                              transform="translate(336.000000, 240.000000)"
                            >
                              <polygon
                                id="Shape"
                                points="0 0 48 0 48 48 0 48"
                              />
                              <path
                                d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                id="Shape"
                                fill="#303778"
                                fill-rule="nonzero"
                              />
                              <polygon
                                id="Shape"
                                fill="#303778"
                                points="10 18 18 18 18 26 10 26"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div>
                      <p>{{ $t("days.off.request.from") }}</p>
                      <span>
                        {{ formatTime(request.from) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-lg-6">
                <div class="step4-card">
                  <div class="d-flex">
                    <div class="svg-wrapper">
                      <svg
                        width="44px"
                        height="44px"
                        viewBox="0 0 44 44"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                        <title>Iconspace_Calendar</title>
                        <desc>Created with Sketch.</desc>
                        <g
                          id="Page-1"
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <g
                            id="Antarmuka_One-Color-UI-element-1"
                            transform="translate(-338.000000, -242.000000)"
                          >
                            <g
                              id="Iconspace_Calendar"
                              transform="translate(336.000000, 240.000000)"
                            >
                              <polygon
                                id="Shape"
                                points="0 0 48 0 48 48 0 48"
                              />
                              <path
                                d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                id="Shape"
                                fill="#303778"
                                fill-rule="nonzero"
                              />
                              <polygon
                                id="Shape"
                                fill="#303778"
                                points="10 18 18 18 18 26 10 26"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div>
                      <p>{{ $t("days.off.request.to") }}</p>
                      <span>
                        {{ formatTime(request.to) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-6 reason">
            <div class="px-md-2">
              <div>
                <h6>{{ $t("days.off.reason.emergency") }}</h6>
                {{ request.motif }}
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="py-2 px-3">
          <h5 class="mb-2" style="color: #b6000a">Vérifiez vos informations puis confirmez la demande</h5>
          <div class="row">
            <div class="col-lg-12">
              <p>Vous souhaitez vous absenter pendant {{ totalHours }} heures du <span style="font-size: 16px;text-decoration: underline;color: #b6000a;">{{ formatDate(request.from) }}</span> au <span style="font-size: 16px;text-decoration: underline;color: #b6000a;">{{ formatDate(request.to) }}</span></p>
            </div>
            <div class="col-lg-6">
                <div>
                  <h6 style="color: #b6000a">Motif :</h6>
                  <span class="font-italic">
                  {{ request.motif }}
                </span>
              </div>
            </div>
          </div>
          <div class="d-flex align-content-end mt-5" style="justify-content: flex-end;">
            <button class="btn btn-danger mr-3" @click="previous">{{ $t('global.return') }}</button>
            <button class="btn btn-success" @click="nextStep">{{ $t('global.save') }}</button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import TimeUtils from '../../../utils/TimeUtils';

export default {
  name: 'StepFourSimple',
  props: ['user', 'request'],
  computed: {
    totalHours() {
      return TimeUtils.getTimeDifferenceBetween(
        this.request.to,
        this.request.from,
      );
    },

    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'btn-group ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },
  methods: {
    formatDate(date) {
      return TimeUtils.formatDate(date);
    },
    formatTime(date) {
      return TimeUtils.formatTime(date);
    },
    previous() {
      this.$emit('input', null);
    },
    nextStep() {
      this.$emit('input', this.totalHours);
    },
  },
};
</script>

<style scoped>
.btn.btn-outline-primary {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  color: #4f78e2;
  border-color: #4f78e2;
  box-shadow: none !important;
}

.btn.btn-outline-primary:hover {
  color: #4f78e2;
  border-color: #4f78e2;
  background-color: transparent;
}

.btn.btn-primary {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  color: #ffffff !important;
}

.reason h6 {
  color: #212529;
  font-size: 20px;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
}
.reason p {
  font-size: 14px;
  font-family: "SF-Pro-Text";
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: -0.41px;
}

@media (max-width: 767px) {
  .reason {
    margin-top: 20px;
  }
}

.step4-card {
  padding: 15px;
  min-height: 70px;
  border-radius: 0;
  border-left: 5px solid #303778;
  margin-bottom: 5px;
  background-color: #f6f8ff;
}
.svg-wrapper svg {
  height: 20px;
}

.step4-card p {
  color: #32356b;
  margin-bottom: 10px;
}
.step4-card span {
  color: #6c7899;
}
</style>
